import { useFormContext } from "react-hook-form";
import { CardSeriesFormSchema } from "@factory/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";

type InputFormSchema = CardSeriesFormSchema;
export function FormCardSeriesActivate() {
  const { control } = useFormContext<CardSeriesFormSchema>();
  return (
    <div id="FormCardSeriesActivate" className="card-series">
      <InputControl<InputFormSchema>
        control={control}
        name="cardCode"
        label="Card Number"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter card number"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="cardOwner"
        label="User Code"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter user / card owner"
      />
    </div>
  );
}

export default FormCardSeriesActivate;
